<template>
  <div id="step-info">
    <div class="ws-textbox mb-4">
      <h2 class="title-choose-photo">
        <u>{{ lang.monetary_compensation_new['SFS_LANG_ROW_2'] }}</u>
      </h2>
      <div v-if="InfoPaxMonetaryDetail.bank_info.transfer_bank_info" class="mt-3 mb-2">
        <p class="bank-info">
          <span :class="[direction == 'rtl' ? 'ml-2' : 'mr-2', 'pay-info-bold']">
            {{ lang.monetary_compensation_new['SFS_LANG_ROW_6'] }}:
          </span>
          <span>{{ InfoPaxMonetaryDetail.bank_info.transfer_bank_info['Account Holder Name'] }}</span>
        </p>
        <p v-if="InfoPaxMonetaryDetail.bank_info.transfer_bank_info.Type == 'Email'" class="bank-info">
          <span :class="[direction == 'rtl' ? 'ml-2' : 'mr-2', 'pay-info-bold']">
            {{ lang.monetary_compensation_new['SFS_LANG_ROW_17'] || 'Email' }}:
          </span>
          <span>{{ InfoPaxMonetaryDetail.bank_info.transfer_bank_info['Email'] }}</span>
        </p>
        <p v-else class="bank-info">
          <span :class="[direction == 'rtl' ? 'ml-2' : 'mr-2', 'pay-info-bold']">
            {{ lang.monetary_compensation_new['SFS_LANG_ROW_7'] }}:
          </span>
          <span>{{
            InfoPaxMonetaryDetail.bank_info.transfer_bank_info[' I B A N'] ||
            InfoPaxMonetaryDetail.bank_info.transfer_bank_info['Account Number']
          }}</span>
        </p>
      </div>
      <h2 class="title-choose-photo">
        <u>{{ lang.monetary_compensation_new['SFS_LANG_ROW_3'] }}</u>
      </h2>
      <div v-if="InfoPaxMonetaryDetail.bank_info.transfer_bank_info" class="mt-3">
        <p>
          <span :class="[direction == 'rtl' ? 'ml-2' : 'mr-2', 'pay-info-bold']">
            {{ lang.monetary_compensation_new['SFS_LANG_ROW_4'] }}:
          </span>
          <span :class="direction == 'rtl' ? 'float-left' : 'float-right'">
            {{ InfoPaxMonetaryDetail?.currency }} {{ totalAmount }}
          </span>
        </p>
      </div>
    </div>
    <div class="button-download text-center">
      <div class="btn-handle">
        <button class="btnDefault btn-email" @click="onOpenEmailPopup()">
          {{ lang.monetary_compensation_new['SFS_LANG_ROW_5'] }}
        </button>
      </div>
    </div>
    <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered>
      <div class="d-flex flex-column align-items-center">
        <template v-if="step == 1">
          <p class="mb-2">
            {{ lang.monetary_compensation_new['SFS_LANG_ROW_8'] }}
          </p>
          <input
            v-model="pax.email_address"
            required
            placeholder="Email"
            type="email"
            class="p-2 input-email-monetary"
            @focus="resetEmailValidate()"
          />
          <p v-if="!isEmailValidate" style="color: red">Email incorrect format!</p>
        </template>
        <template v-else-if="step == 2">
          <i style="color: #16c166; font-size: 5rem; margin-bottom: 1rem" class="fas fa-check-circle"></i>
          <p style="font-size: 20px">{{ lang.monetary_compensation_new['SFS_LANG_ROW_9'] }}</p>
        </template>
      </div>
      <template #modal-footer>
        <div v-if="step == 1" class="ws-modal__footer w-100">
          <button class="btnDefault" @click="isOpenPopup = !isOpenPopup">{{ lang.monetary_compensation_new['CANCEL'] }}</button>
          <button class="btnDefault" @click="sendEmailConfirm()">{{ lang.monetary_compensation_new['CONFIRM'] }}</button>
        </div>
        <div v-else></div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { replaceStr } from '@/utils/helper'
export default {
  name: 'MonetaryCompensationConfirm',
  props: {
    secret: {
      type: String,
      default: ''
    },
    service: {
      type: Object,
      default: () => {}
    },
    InfoPaxMonetaryDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isOpenPopup: false,
      step: 1,
      isEmailValidate: true,
      timeDisappears: 5000
    }
  },
  computed: {
    totalAmount() {
      return parseFloat(this.InfoPaxMonetaryDetail.infoCashOrder.amount).toFixed(2) || 0
    }
  },
  methods: {
    replaceStr,
    validateEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    onOpenEmailPopup: function () {
      this.isOpenPopup = !this.isOpenPopup
      this.step = 1
    },
    resetEmailValidate: function () {
      this.isEmailValidate = true
    },
    sendEmailConfirm: function () {
      var self = this
      if (!this.validateEmail(this.pax.email_address)) {
        this.isEmailValidate = false
        return
      }
      let dataSend = {
        data: {
          email: this.pax.email_address,
          credit: this.InfoPaxMonetaryDetail.bank_info.target_amount,
          claimed: parseFloat(this.InfoPaxMonetaryDetail.infoCashOrder.amount).toFixed(2),
          transferred: this.InfoPaxMonetaryDetail.bank_info.target_amount,
          currency: this.InfoPaxMonetaryDetail.bank_info?.currency,
          full_name: this.pax.full_name,
          iban:
            this.InfoPaxMonetaryDetail.bank_info.transfer_bank_info[' I B A N'] ||
            this.InfoPaxMonetaryDetail.bank_info.transfer_bank_info['Account Number'],
          transferId: this.InfoPaxMonetaryDetail.bank_info.transfer_id,
          secret: self.secret,
          block_code: this.InfoPaxMonetaryDetail.bank_info.block_code || '',
          voucher_code: this.InfoPaxMonetaryDetail.bank_info.voucher_code || ''
        },
        secret: self.secret
      }
      this.$store.dispatch('sendEmailConfirmReceipt', dataSend).then((response) => {
        if (response) {
          if (response.success == false) {
            this.isOpenPopup = !this.isOpenPopup
            return
          }
          this.step = 2
          setTimeout(
            function () {
              self.isOpenPopup = false
            },
            self.timeDisappears,
            self
          )
        }
      })
    },
    getDate() {
      if (this.InfoPaxMonetaryDetail.infoCashOrder.created_at) {
        const date = new Date(this.InfoPaxMonetaryDetail.infoCashOrder.created_at)
        const fullYear = date.getFullYear()
        const month = `0${date.getMonth() + 1}`.slice(-2)
        const day = `0${date.getDate()}`.slice(-2)
        return `${fullYear}-${month}-${day}`
      }
      return ''
    },
    getTime() {
      if (this.InfoPaxMonetaryDetail.infoCashOrder.created_at) {
        const date = new Date(this.InfoPaxMonetaryDetail.infoCashOrder.created_at)
        const hour = `0${date.getHours()}`.slice(-2)
        const minute = `0${date.getMinutes()}`.slice(-2)
        const second = `0${date.getSeconds()}`.slice(-2)

        return `${hour}:${minute}:${second}`
      }
      return ''
    }
  }
}
</script>
